import { OnInit, Input, Output, EventEmitter,Component, ViewChild, Directive} from '@angular/core';
import { CommonDataResolver } from '../CommonData/CommonDataResolver';
import { isUndefined, isNullOrUndefined } from '../objectUtils';
import { ModalService } from '../Modal/ModalService';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgForm } from '@angular/forms';

@Directive()
export class TableEditBase<T> implements OnInit {

  @Input() itemList: T[] = <T[]>[];
  @Input() editIndex: number = null;
  @Input() preFilledItem: T = <T>{};
  @Output() listChanged = new EventEmitter<T[]>();
  @ViewChild('tableItemEditForm', { read: NgForm }) tableItemEditForm;
  public item: T = <T>{};
  public isEdit: boolean = false;
  private _modalService: ModalService;


  constructor(parent: Component,modalService : ModalService) {
    if (!isNullOrUndefined(parent))
      CommonDataResolver.getParentComponentCommonData(this, parent);
    if (!isNullOrUndefined(modalService))
      this._modalService = modalService;
  }

  ngOnInit(): void {
    this.isEdit = !isNullOrUndefined(this.editIndex);
    //Need to spread the object to avoid realtime changes to the main list
    this.item = this.isEdit ? { ...this.itemList[this.editIndex] } : { ...this.preFilledItem };
  }

  ngOnDestroy(): void {
  }

  onEdit(isEdit: boolean) {
    //Necessário setar o touched em todos os imputs no seguinte de forma a que as mensagens de erro apareçam
    this.markTouched();
    
    if (!this.tableItemEditForm.valid)
      return;
    if (isEdit)
      this.itemList.splice(this.editIndex, 1, this.item);
    else
      this.itemList.push(this.item);

    this.listChanged.emit(this.itemList);
  }

  onRemove(isEdit: boolean) {
    var listToAlter = [...this.itemList];
    if (isEdit)
      confirmRemoveFromList(listToAlter, this.editIndex, this._modalService).subscribe(result => {
        if (result)
          this.listChanged.emit(listToAlter);
      });
    else
      this.listChanged.emit(listToAlter);
  }

  markTouched() {
    Object.keys(this.tableItemEditForm.controls).forEach(controlKey => {
      this.tableItemEditForm.controls[controlKey].markAsTouched();
    })
  }

  checkValid() {
    return this.tableItemEditForm.valid;
  }

}

//Serviço do modal tem de ser providenciado por falta de injeção de dependencias em metodos estáticos;
//poderá existir uma maneira melhor de fazer isto
export function confirmRemoveFromList(currentList: any[], indexToRemove: number,modalService : ModalService) : Observable<boolean> {
  var baseModal = <models.BaseModalVM>{ isError: false, message: "BaseModal.ConfirmRemoveFromList" };
  return modalService.showModals([baseModal]).pipe(map(result => {
    if (result)
      currentList.splice(indexToRemove, 1);

    return result;
  }));
}
